export default __webpack_public_path__ + "static/media/Primary-ShortAnswer.9fd1a8ff.svg";